import React from "react";
import { Link } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { StatusBadge, ProgressBar } from "@/components/domain/Bits";
import { money, num, RAFFLE_STATUS, raffleImg, onImgError } from "@/lib/format";
import { Ticket, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

const canSeeInventory = (user) => ["admin", "tenant_owner", "superadmin"].includes(user?.role);

export default function RaffleCard({ raffle, index = 0 }) {
  const { user } = useAuth();
  const showInventory = canSeeInventory(user);
  const st = RAFFLE_STATUS[raffle.status] || RAFFLE_STATUS.active;
  const disabled = !["active", "live"].includes(raffle.status);
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
    >
      <Link to={`/sorteos/${raffle.id}`} data-testid={`raffle-card-${raffle.id}`}
        className="group block overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand/40 hover:shadow-xl">
        <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
          <img src={raffleImg(raffle)} onError={onImgError} alt={raffle.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <div className="absolute left-3 top-3"><StatusBadge label={st.label} cls={st.cls} /></div>
        </div>
        <div className="p-5">
          <h3 className="line-clamp-1 text-lg font-bold tracking-tight text-slate-900">{raffle.name}</h3>
          <p className="mt-1 line-clamp-1 text-sm text-slate-500">{raffle.prize}</p>
          <div className="mt-4 flex items-end justify-between">
            <div>
              <div className="text-xs text-slate-400">Boleto desde</div>
              <div className="font-mono text-xl font-bold text-slate-900">{money(raffle.price)}</div>
            </div>
            <div className="text-right">
              <div className="text-xs text-slate-400">Progreso</div>
              <div className="font-mono text-lg font-semibold text-brand">{raffle.progress}%</div>
            </div>
          </div>
          <div className="mt-3"><ProgressBar value={raffle.progress} /></div>
          <div className="mt-2 flex items-center justify-between text-xs text-slate-400">
            {showInventory
              ? <span className="inline-flex items-center gap-1" data-testid="card-inventory"><Ticket className="h-3.5 w-3.5" />{num(raffle.available)} disponibles</span>
              : <span />}
            <span className="inline-flex items-center gap-1 font-semibold text-brand group-hover:gap-2 transition-all">
              {disabled ? "Ver detalle" : "Participar"} <ArrowRight className="h-3.5 w-3.5" />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
